import React, { lazy, Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { Hero } from './components/sections/Hero';
import { SocialStats } from './components/sections/SocialStats';
import { Pain } from './components/sections/Pain';
const DeferredContent = lazy(() => import('./components/sections/DeferredContent').then(({
  DeferredContent: Content
}) => ({
  default: Content
})));
export function App() {
  const deferredTriggerRef = useRef<HTMLDivElement>(null);
  const [shouldLoadDeferred, setShouldLoadDeferred] = useState(false);
  const [isDeferredReady, setIsDeferredReady] = useState(false);
  const [shouldFocusPricing, setShouldFocusPricing] = useState(false);
  const revealPricing = useCallback(() => {
    setShouldFocusPricing(true);
    setShouldLoadDeferred(true);
  }, []);
  const markDeferredReady = useCallback(() => {
    setIsDeferredReady(true);
  }, []);
  useEffect(() => {
    const trigger = deferredTriggerRef.current;
    if (!trigger) return undefined;
    if (!('IntersectionObserver' in window)) {
      setShouldLoadDeferred(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoadDeferred(true);
      observer.disconnect();
    }, {
      rootMargin: '280px 0px'
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!shouldFocusPricing || !isDeferredReady) return;
    const frame = window.requestAnimationFrame(() => {
      const pricing = document.getElementById('pricing');
      if (!pricing) return;
      pricing.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      window.setTimeout(() => document.getElementById('pricing-title')?.focus(), 350);
      setShouldFocusPricing(false);
    });
    return () => window.cancelAnimationFrame(frame);
  }, [isDeferredReady, shouldFocusPricing]);
  return <main className="w-full min-h-full bg-ink text-white" data-id="element-0" data-mp="ssssyvl40qdk">
      <Hero onCta={revealPricing} data-id="element-1" data-mp="35ovwnmbgyrj" />
      <SocialStats data-id="element-2" data-mp="34ncnvv5d5yq" />
      <Pain data-id="element-3" data-mp="38b2ajxh1886" />
      <div ref={deferredTriggerRef} className="h-px" aria-hidden="true" data-id="element-4" data-mp="3ud1g7bihxsbo" />
      {shouldLoadDeferred && <Suspense fallback={<div className="min-h-px" aria-hidden="true" data-id="element-6" data-mp="d3mlbefwx1lq" />} data-id="element-5" data-mp="d57g95652mk4">
          <DeferredContent onCta={revealPricing} onReady={markDeferredReady} data-id="element-7" data-mp="85l3sxy4xacd" />
        </Suspense>}
    </main>;
}